enum EmailProviderType {
  Client = 1,
  Develop = 2,
}

export default EmailProviderType
